import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListTodo, CalendarClock } from "lucide-react";
import { api } from "../../lib/api";
import { statusMeta, isOverdue, formatDue } from "./taskMeta";

export const MyTasksWidget = () => {
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    api
      .get("/tasks", { params: { scope: "mine" } })
      .then(({ data }) => setTasks(data.filter((t) => t.status !== "tamamlandi")))
      .catch(() => setTasks([]));
  }, []);

  if (tasks === null) return null;

  return (
    <div data-testid="dashboard-my-tasks" className="hard border border-[color:var(--border)] bg-[color:var(--surface)]">
      <div className="p-4 border-b border-[color:var(--border)] flex items-center gap-2">
        <ListTodo size={16} />
        <h3 className="font-bold">Görevlerim</h3>
        <span data-testid="dashboard-my-tasks-count" className="px-2 py-0.5 hard text-[10px] font-bold bg-[color:var(--primary)] text-white">
          {tasks.length} açık
        </span>
        <Link to="/gorevler" data-testid="dashboard-my-tasks-link" className="ml-auto ticker text-[10px] text-[color:var(--primary)] hover:underline">
          Tümü →
        </Link>
      </div>
      {tasks.length === 0 ? (
        <div className="p-6 text-sm text-center text-[color:var(--text-3)]">Size atanmış açık görev yok.</div>
      ) : (
        <ul className="divide-y divide-[color:var(--border)]">
          {tasks.slice(0, 5).map((t) => {
            const meta = statusMeta(t.status);
            const overdue = isOverdue(t);
            return (
              <li key={t.id} data-testid="dashboard-my-task-item" className="px-4 py-2.5 flex items-center gap-3 text-sm">
                <span className={`px-2 py-0.5 hard text-[10px] font-bold uppercase ${meta.cls}`}>{meta.label}</span>
                <span className="font-semibold truncate flex-1">{t.title}</span>
                <span className={`flex items-center gap-1 text-xs ${overdue ? "text-[color:var(--error)] font-bold" : "text-[color:var(--text-3)]"}`}>
                  <CalendarClock size={12} /> {formatDue(t.due_date)}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
